import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const whatsappPackageStatus = async () => {
	const WABA_ID = localStorage.getItem('WABA_ID') || '';
	try {
		const url = `/whatsapp/package-status?waba_id=${WABA_ID}`;
		const resp: any = await networkCall('get', url, apiBaseUrl.baseUrl);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const getWabaIds = async () => {
	try {
		const url = `/whatsapp/waba-ids?fetch_business_name=1&fetch_version=1`;
		const resp: any = await networkCall('get', url, apiBaseUrl.baseUrl);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const getMessageUsage = async (fromNumber: any) => {
	try {
		const url = `/whatsapp/number/usage?number=${fromNumber}`;
		const resp: any = await networkCall('get', url, apiBaseUrl.baseUrl);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const getValidDateTime = async (tzone: any, sel_date?: any) => {
	try {
		let url = `/campaigns/getdatetime?tzone=${tzone}`;
		if (sel_date) {
			url += `&sel_date=${sel_date}`;
		}
		const resp: any = await networkCall(
			'get',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const deleteCampaign = async (
	campaignType: string,
	campaignName: string,
	campaignId: string
) => {
	try {
		let url = `/campaigns/delete?activity_log_action=Deleted&activity_log_object=${campaignType}&activity_log_object_value=${campaignName}&campaign_id=${campaignId}`;
		const resp: any = await networkCall(
			'delete',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const deleteBatch = async (
	campaignType: string,
	campaignName: string,
	batchId: string
) => {
	try {
		let url = `/campaigns/batchDelete?activity_log_action=Deleted&activity_log_object=${campaignType}&activity_log_object_value=${campaignName}&batch_id=${batchId}`;
		const resp: any = await networkCall(
			'delete',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const editBatch = async (
	campaignType: string,
	campaignName: string | undefined,
	time: string | undefined,
	batchId: string | undefined,
	date: string | undefined,
	timezone: string | undefined
) => {
	try {
		let url = `/campaigns/update/time`;
		let data = `activity_log_action=Updated Scheduled time&activity_log_object=${campaignType}&activity_log_object_value=${campaignName}&to_time=${time}&to_batch_id=${batchId}&to_date=${date}&to_timezone=${timezone}`;
		const resp: any = await networkCall(
			'post',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true,
			data
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const executeCampaign = async (
	campaignId: string,
	campaignName: string
) => {
	try {
		let url = `/campaigns/execute`;
		let data = `campaign_id=${campaignId}&activity_log_action=Executed&activity_log_object=DRAFT+WHATSAPP+CAMPAIGN&activity_log_object_value=${campaignName}`;
		const resp: any = await networkCall(
			'post',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true,
			data
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const executeScheduledCampaign = async (
	campaignId: string,
	campaignName: string
) => {
	const config = {
		headers: {
			Accept: 'application/json',
		},
	};
	try {
		let url = `/campaigns/execute/schedule`;
		let data = `campaign_id=${campaignId}&activity_log_action=Executed&activity_log_object=SCHEDULED+WHATSAPP+CAMPAIGN&activity_log_object_value=${campaignName}`;
		const resp: any = await networkCall(
			'post',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true,
			data
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};

export const requestReport = async (
	campaignKid: string,
	campaignName: string,
	createdAt: string,
	updatedAt: string
) => {
	try {
		let url = `/campaigns/request/report?campaign_kid=${campaignKid}&report_name=${campaignName}&created_at=${createdAt}&updated_at=${updatedAt}&channel=whatsapp`;
		const resp: any = await networkCall(
			'get',
			url,
			apiBaseUrl.redirectUrl,
			false,
			true
		);
		return resp;
	} catch (e) {
		console.log('Error', e);
	}
};
